import React, { FC } from 'react';
import styles from './header_content.module.scss';
import { Container } from '../components/grid/Grid';

export const HeaderContent: FC = ({ children }) => (
  <Container className={styles.container}>{children}</Container>
);
